export default "__VITE_ASSET__DeUshMN7__"